window.o_shoppages ||= {} as never;

export const {
  o_shoppages
} = window;
